import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/exchange/expired_seal.png';
import _imports_1 from '@/assets/img/exchange/used_seal.png';
const _withScopeId = n => (_pushScopeId("data-v-1c0b159e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "codePage" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "clickEntry" }, "手工输入", -1));
const _hoisted_3 = { class: "tabList flex-align-center" };
const _hoisted_4 = { class: "p-lr32 p-t20" };
const _hoisted_5 = { class: "list" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "roundBox" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "round1 ig-border-2 border-box" }),
    /*#__PURE__*/ _createElementVNode("div", { class: "round2 ig-border-2 border-box" })
], -1));
const _hoisted_7 = { class: "couponInfo flex-align-center border-box" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "exchangeButton exchangeColor font-24 font-w500" }, " 立即兑换 ", -1));
const _hoisted_9 = {
    key: 1,
    class: "expiredImg"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "exchangeButton detailColor font-24 font-w500" }, " 兑换详情 ", -1));
const _hoisted_12 = {
    key: 2,
    class: "expiredImg"
};
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: ""
}, null, -1));
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = { class: "desc p-lr32 flex-between gray-9 font-24 p-tb16" };
const _hoisted_16 = { class: "left" };
const _hoisted_17 = { class: "time" };
const _hoisted_18 = { class: "noMore" };
import Empty from '@/components/common/Empty.vue';
import { codeSearch } from '@/api/exchange';
import { appPort, closeWebView, isLogin, userLogin, hiddenAppNavBar } from '@/widget/index';
import BetterScroll from '@/components/common/BetterScroll.vue';
import Header from '@/components/common/Header.vue';
import { onMounted, ref, getCurrentInstance } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { proxy: { $showLoading, $hideLoading } } = getCurrentInstance();
        const isApp = ref(appPort());
        // USED:已使用,NOT_USED:未使用,EXPIRED:已过期
        const tabVal = ref('NOT_USED');
        const tabsNum = ref({});
        const codeData = ref([]);
        const pageNo = ref(1);
        const pageCount = ref(1);
        const noMore = ref(false);
        const loaded = ref(false);
        /* 返回 */
        const backFn = () => {
            if (isApp.value) {
                closeWebView();
            }
            else {
                history.go(-1);
            }
        };
        const selectTab = val => {
            tabVal.value = val;
            pageNo.value = 1;
            getData();
        };
        const getData = () => {
            $showLoading();
            loaded.value = false;
            codeSearch({
                page: pageNo.value,
                filter: tabVal.value
            }).then((res) => {
                $hideLoading();
                loaded.value = true;
                if (res.code === 200) {
                    tabsNum.value = res.data.tabs;
                    pageCount.value = res.data.pages;
                    if (pageNo.value == 1) {
                        codeData.value = res.data.items;
                    }
                    else {
                        codeData.value = codeData.value.concat(res.data.items);
                    }
                    if (pageNo.value >= pageCount.value) {
                        noMore.value = true;
                    }
                    else {
                        noMore.value = false;
                        pageNo.value++;
                    }
                }
            });
        };
        /* app里隐藏头部 */
        if (isApp.value) {
            hiddenAppNavBar();
        }
        onMounted(() => {
            if (!isLogin) {
                userLogin();
                return;
            }
            getData();
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    onBackFn: backFn,
                    showBack: true,
                    isColor: true,
                    pageTitle: '兑换码'
                }, {
                    shareBtn: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/exchange/code/manual" }, {
                            default: _withCtx(() => [
                                _hoisted_2
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createElementVNode("ul", _hoisted_3, [
                    _createElementVNode("li", {
                        class: _normalizeClass(["tabItem", { active: tabVal.value === 'NOT_USED' }]),
                        onClick: _cache[0] || (_cache[0] = ($event) => (selectTab('NOT_USED')))
                    }, " 未使用（" + _toDisplayString(tabsNum.value.notUsedCount) + "） ", 3),
                    _createElementVNode("li", {
                        class: _normalizeClass(["tabItem", { active: tabVal.value === 'USED' }]),
                        onClick: _cache[1] || (_cache[1] = ($event) => (selectTab('USED')))
                    }, " 已使用（" + _toDisplayString(tabsNum.value.usedCount) + "） ", 3),
                    _createElementVNode("li", {
                        class: _normalizeClass(["tabItem", { active: tabVal.value === 'EXPIRED' }]),
                        onClick: _cache[2] || (_cache[2] = ($event) => (selectTab('EXPIRED')))
                    }, " 已过期（" + _toDisplayString(tabsNum.value.expiredCount) + "） ", 3)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(BetterScroll, {
                        options: {
                            scrollY: true,
                            scrollX: false,
                            click: true,
                            mouseWheel: true,
                            scrollbar: {
                                fade: false,
                                interactive: true
                            }
                        },
                        loaded: loaded.value,
                        noMore: noMore.value,
                        domStyle: {
                            position: 'relative',
                            height: 'calc(100vh - 1.5rem)',
                            width: '6.86rem'
                        }
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codeData.value, (item, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: _normalizeClass(["ig-border-2", [
                                                tabVal.value === 'NOT_USED'
                                                    ? 'unusedBg'
                                                    : tabVal.value === 'USED' || tabVal.value === 'EXPIRED'
                                                        ? 'utilizedBg'
                                                        : ''
                                            ]]),
                                        key: index
                                    }, [
                                        _hoisted_6,
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["name text-overflow flex-1 font-w500 font-40", { colorGray: tabVal.value !== 'NOT_USED' }])
                                            }, _toDisplayString(item.code), 3),
                                            (tabVal.value === 'NOT_USED')
                                                ? (_openBlock(), _createBlock(_component_router_link, {
                                                    key: 0,
                                                    to: {
                                                        name: 'exchangeSelectCourse',
                                                        params: { code: item.code }
                                                    }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_8
                                                    ]),
                                                    _: 2
                                                }, 1032, ["to"]))
                                                : (tabVal.value === 'USED')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                        _createVNode(_component_router_link, {
                                                            to: {
                                                                name: 'exchangeDetail',
                                                                params: { code: item.code }
                                                            }
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _hoisted_10,
                                                                _hoisted_11
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to"])
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("div", _hoisted_17, "有效期至 " + _toDisplayString(item.endedDate), 1)
                                            ])
                                        ])
                                    ], 2));
                                }), 128))
                            ]),
                            _withDirectives(_createVNode(Empty, { text: '暂无内容，探索一下其他内容吧~' }, null, 512), [
                                [_vShow, noMore.value && codeData.value.length === 0]
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_18, " 没有更多了 ", 512), [
                                [_vShow, noMore.value && pageCount.value === pageNo.value]
                            ])
                        ]),
                        _: 1
                    }, 8, ["loaded", "noMore", "domStyle"])
                ])
            ]));
        };
    }
});
